import React from 'react';
import TextWidget from '../TextWidget/TextWidget'

class DailyReminderWidget extends React.Component {

  constructor() {
    super();
    this.state = {
      day: 0
    };
  }

  refresh() {
    this.setState({
      ...this.state,
      day: new Date().getDay()
    });
  }

  componentDidMount() {
    this.refresh()
  }

  getDailyReminderText() {

    switch (this.state.day) {
      case 0:
        return this.props.sunday;
      case 1:
        return this.props.monday;
      case 2:
        return this.props.tuesday;
      case 3:
        return this.props.wednesday;
      case 4:
        return this.props.thursday;
      case 5:
        return this.props.friday;
      case 6:
        return this.props.saturday;
      default:
        return "N/A"
    }

  }

  render() {
    return (
      <TextWidget {...this.props} onWidgetRefresh={this.refresh.bind(this)} refreshInterval={1800} value={this.getDailyReminderText()}/>
    )
  }
}

export default DailyReminderWidget;



// WEBPACK FOOTER //
// ./src/components/Dashboard/components/DailyReminderWidget/DailyReminderWidget.js